module.exports = __webpack_public_path__ + "img/step_metafield_3.c0528f7b.png";